import React from 'react';
import { connect } from 'react-redux';
import * as reducers from '../../store/reducers';

import Form from 'Components/Form';

class LoginAgainForm extends React.Component {
  render() {
    const { activeUser, referringFormId, referringFormName } = this.props;
    return (
      <Form
        type="loginAgain"
        id="loginAgain"
        formStyle="login"
        submitArgs={{ referringFormId, referringFormName }}
        initialFieldSettings={{
          username: { value: activeUser.auth_info.username },
        }}
        messagePosition="page-top"
        submitButtonType="primary"
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    activeUser: reducers.getActiveUser(state),
  };
};

export default connect(mapStateToProps, {})(LoginAgainForm);
